import { forwardRef, useImperativeHandle, useState, } from "react"
import BSelect from "@/components/b-select.jsx"
import BInput from "@/components/b-input.jsx"
import Paging from "@/components/paging.jsx"
import http from "@/http"
import { useTranslation } from "react-i18next";
export default forwardRef((props, ref) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    orderByColumn: props.orderByColumn || "top desc, create_time",
    title: "",
    isAsc: "desc",
    pageSize: 10
  })
  const pageNumList = [
    { label: t('announcement.page_10'), value: 10 },
    { label: t('announcement.20per page'), value: 20 }
  ]
  // useImperativeHandle(ref, {
  // })
  let [pageNum, setPageNum] = useState(0)
  let [pageSize, setPageSize] = useState(10)
  let paging = Paging({
    request: (data) => http.get(props.url, { ...data, ...formData }).then(res => {
      setPageNum(data.pageNum)
      setPageSize(data.pageSize)
      return res
    })
  })
  const select = (val, key) => {
    formData[key] = val
    setFormData({ ...formData })
    paging.reset()
  }
  const submit = (event) => { event.preventDefault(), paging.reset() };
  return <div>
    <h2 className="page-title">{props.title}</h2>
    <div className="title-tool">
      <h2 className="page-title"></h2>
      <form className="tool" onSubmit={submit}>
        {/* <BSelect className="sm" value={formData.orderByColumn} onChange={(val) => select(val, 'orderByColumn')} list={[{ label: "title", value: props.orderByColumn || "title" }]} /> */}
        <BInput className="sm" value={formData.title} onChange={({ target: { value } }) => setFormData({ ...formData, title: value })} after={<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={submit}>
          <path d="M16.5208 18.0423L11.2292 12.7507C10.8125 13.0701 10.3021 13.3236 9.69792 13.5111C9.09375 13.6986 8.47917 13.7923 7.85417 13.7923C6.20139 13.7923 4.80208 13.2194 3.65625 12.0736C2.51042 10.9277 1.9375 9.52843 1.9375 7.87565C1.9375 6.22287 2.51042 4.82357 3.65625 3.67773C4.80208 2.5319 6.20139 1.95898 7.85417 1.95898C9.50694 1.95898 10.9062 2.5319 12.0521 3.67773C13.1979 4.82357 13.7708 6.22287 13.7708 7.87565C13.7708 8.50065 13.684 9.09787 13.5104 9.66732C13.3368 10.2368 13.0833 10.7437 12.75 11.1882L18.0625 16.5007L16.5208 18.0423ZM7.85417 11.584C8.89583 11.584 9.77431 11.2263 10.4896 10.5111C11.2049 9.79579 11.5625 8.91732 11.5625 7.87565C11.5625 6.83398 11.2049 5.95551 10.4896 5.24023C9.77431 4.52496 8.89583 4.16732 7.85417 4.16732C6.8125 4.16732 5.93403 4.52496 5.21875 5.24023C4.50347 5.95551 4.14583 6.83398 4.14583 7.87565C4.14583 8.91732 4.50347 9.79579 5.21875 10.5111C5.93403 11.2263 6.8125 11.584 7.85417 11.584Z" fill="#576059" />
        </svg>
        } />
        <BSelect className="sm" value={formData.isAsc} onChange={(val) => select(val, 'isAsc')} list={[{ label: t('announcement.Latest'), value: "asc" }, { label: t('announcement.Oldest'), value: "desc" }]} />
        <BSelect className="sm" value={formData.pageSize} onChange={(val) => select(val, 'pageSize')} list={pageNumList} />
      </form>
    </div>
    {paging((list) => <>
      {props.children && props.children({ list, pageNum, pageSize, paging })}
      <span style={{ color: "#A8B6AF", fontSize: "12px", marginTop: "10px", display: "block" }}>Total Posts {paging.getTotal()}</span>
    </>
    )}
  </div >


})